import { AdminRouteName } from '../../../CONSTANTS';
import GuaranteeTableRecords from '../../_partials/GuaranteesTableRecords';

const optionalColumn = [
  'datePaid',
  'dateActioned',
];

const optionalColumnLabelFormat = {
  datePaid: 'Date Paid',
  dateActioned: 'Date Actioned',
};

const PaidGuarantees = ({ TabsRaw }: any) => (
  <GuaranteeTableRecords
    TabsRaw={TabsRaw}
    optionalColumn={optionalColumn}
    optionalColumnLabelFormat={optionalColumnLabelFormat}
    tabStatus="PAID"
    defaultUrl={AdminRouteName.paidGuaranteesRoute}
    toggleStorageId="paid-guarantees-table-col"
    hasNameAndImage
    permissionName="can-view-paid-guarantees"
  />
);
export default PaidGuarantees;
